import { ApplicationAndTime } from "@shared/service-proxies/service-proxies"

export class ProductivityCandle {
    constructor(
        isDataAvailable: boolean,
        productivePercent?: number, 
        unproductivePercent?: number,
        neutralPercent?: number,
        privatePercent?: number,
        productiveAppData?: ApplicationAndTime[],
        unproductiveAppData?: ApplicationAndTime[],
        neutralAppData?: ApplicationAndTime[],
        privateAppData?: ApplicationAndTime[],
        isManualTime?: boolean,
        isApproved?: boolean,
        date?: Date ,
        TotalMinutes?:number
    ) {
        this.isDataAvailable = isDataAvailable
        this.productivePercent = productivePercent
        this.unproductivePercent = unproductivePercent
        this.neutralPercent = neutralPercent
        this.privatePercent = privatePercent
        this.productiveAppData = productiveAppData
        this.neutralAppData = neutralAppData
        this.privateAppData = privateAppData
        this.unproductiveAppData = unproductiveAppData
        this.date = date;
        this.isManualTime = isManualTime;
        this.isApproved = isApproved;
        this.TotalMinutes = TotalMinutes
    }  
    public isDataAvailable: boolean;  
    public isManualTime: boolean;
    public isApproved: boolean;
    public productivePercent?: number;  
    public unproductivePercent?: number;  
    public neutralPercent?: number;  
    public privatePercent?: number;  
    public productiveAppData?: ApplicationAndTime[];
    public unproductiveAppData?: ApplicationAndTime[];
    public neutralAppData?: ApplicationAndTime[];
    public privateAppData?: ApplicationAndTime[];
    public date?: Date;
    public TotalMinutes? : number;

    public makeAllProductive(desc: string) {
        this.productivePercent = 100;
        this.unproductivePercent = 0;
        this.neutralPercent = 0;
        this.productiveAppData = [new ApplicationAndTime({'applicationName': desc, 'usedTime': null, 'productiveType': 1})]
    }
    public makeAllUnproductive(desc: string) {
        this.productivePercent = 0;
        this.unproductivePercent = 100;
        this.neutralPercent = 0;
        this.unproductiveAppData = [new ApplicationAndTime({'applicationName': desc, 'usedTime': null, 'productiveType': 2})]
    }
    public makeAllNeutral(desc: string) {
        this.productivePercent = 0;
        this.unproductivePercent = 0;
        this.neutralPercent = 100;
        this.neutralAppData = [new ApplicationAndTime({'applicationName': desc, 'usedTime': null, 'productiveType': 3})]
    }
}